'use client'

import React from 'react'

import { MProgramCard } from '../../../components/program-card'
import { cn } from '../../../utils/cn'

import type { IMAnnulProgramsGridProps } from './_types/types'

/**
 * MAnnulProgramsGrid Block Component
 *
 * Container block for displaying multiple program cards in a responsive grid layout.
 * Supports optional eyebrow text and automatically handles responsive column layout:
 * - Mobile: 1 column
 * - Tablet (640px+): 2 columns
 * - Desktop (1024px+): 3 columns
 * Grid is centered with max-width 1120px.
 *
 * @example
 * ```tsx
 * <MAnnulProgramsGrid
 *   eyebrow="Naše programy"
 *   programs={[
 *     {
 *       id: 1,
 *       title: "Medante Vital",
 *       subtitle: "Ročný program",
 *       price: 299,
 *       color: "cyclamen",
 *       items: [...],
 *       orderUrl: '/volne-terminy?type=annual-program&id=1'
 *     },
 *     // ... more programs
 *   ]}
 * />
 * ```
 */
export const MAnnulProgramsGrid: React.FC<IMAnnulProgramsGridProps> = ({
	eyebrow,
	programs,
	className,
	style
}) => {
	return (
		<section className={cn('m-annul-programs-grid', className)} style={style}>
			{eyebrow && <div className='m-annul-programs-grid__eyebrow'>{eyebrow}</div>}
			<div className='m-annul-programs-grid__grid'>
				{programs.map(program => (
					<MProgramCard key={program.id} program={program} />
				))}
			</div>
		</section>
	)
}

MAnnulProgramsGrid.displayName = 'MAnnulProgramsGrid'
